import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  OFFERS_ADD_PATH,
  OFFERS_PATH,
  OFFERS_UPDATE_PATH,
} from "utils/constants/paths";

const Offers = Loadable(React.lazy(() => import("./View")));
const OffersAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const OffersRoute: IRouteItem = {
  path: OFFERS_PATH,
  iconName: "ReceiptDisscount",
  element: React.createElement(Offers),
  name: "Offers",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: OFFERS_ADD_PATH,
      element: React.createElement(OffersAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: OFFERS_UPDATE_PATH,
      element: React.createElement(OffersAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
